import React from "react";
import leftImg from "../assets/left.png";
import rightImg from "../assets/right.png";
import animationVideo from "../assets/animation.mp4";

export default function CoreflowfitApp() {
  return (
    <div className="container mt-5 text-center" id="trail-section">

      {/* Heading */}
      <h3 className="coach mb-3">COREFLOWFIT APP</h3>

      {/* Notes */}
      <p className="notes mb-4">
        Personal notes, cues and mini plans I give my clients <br />
        Updated daily, weekly, or monthly so you always <br />
        know what to do next
      </p>

      {/* Download Buttons */}
      <div className="d-flex justify-content-center align-items-center gap-3 app-buttons mb-5 flex-wrap">
        <button className="app-download-btn btn-ios">
          <i className="fa-brands fa-apple"></i> Download iOS
        </button>
        <button className="app-download-btn btn-android">
          <i className="fa-brands fa-android"></i> Download Android
        </button>
      </div>

      {/* Middle Row: Left Image | Video | Right Image */}
      <div className="d-flex justify-content-center align-items-center gap-4 flex-wrap middle-row">
        <img src={leftImg} alt="Left" className="app-img animate-left" />
        <video 
          src={animationVideo} 
          className="app-video animate-center" 
          autoPlay 
          loop 
          muted 
        />
        <img src={rightImg} alt="Right" className="app-img animate-right" />
      </div>

    </div>
  );
}